module.exports = __webpack_public_path__ + "img/1485501287.8c0ae2a6.jpg";